module.exports = __webpack_public_path__ + "img/drawer_safe.059353fe.svg";